import React, { useEffect, useRef, useState } from 'react';
import { animated, useSpring } from 'react-spring';
import RemoveIcon from '../../../../../../svg/icons/remove.svg';
import appliedFacetsStyles from './appliedFacets.module.pcss';
import { BreadcrumbData, MessageProperties } from '../../../../types';

interface AppliedFacetsProps {
  appliedFacets: BreadcrumbData[];
  isExpanded: boolean;
  isDisabled: boolean;
  clearHandler: () => void;
  removeHandler: (location: string) => void;
  messages: MessageProperties;
}

function AppliedFacets({
  appliedFacets,
  isExpanded,
  isDisabled,
  clearHandler,
  removeHandler,
  messages
}: AppliedFacetsProps): React.ReactElement {
  const ref = useRef<HTMLDivElement>(null);
  const [scrollHeight, setScrollHeight] = useState(0);

  const height = useSpring({
    height: isExpanded ? scrollHeight : 0,
    config: { duration: 350 }
  });

  useEffect(() => {
    setScrollHeight(ref.current?.scrollHeight || 0);
  }, [appliedFacets]);

  return (
    <animated.div style={height} className={appliedFacetsStyles['applied-facets']}>
      <div ref={ref} className={appliedFacetsStyles['applied-facets__content']}>
        <p className={appliedFacetsStyles['applied-facets__title']}>{messages.title}</p>
        <button
          type="button"
          disabled={isDisabled}
          onClick={clearHandler}
          className={appliedFacetsStyles['applied-facets__clear']}
        >
          <span className={appliedFacetsStyles['applied-facets__clear-text']}>{messages.clearLabel}</span>
        </button>
        <ul className={`${appliedFacetsStyles['applied-facets__bubbles']} ${appliedFacetsStyles.bubbles}`}>
          {appliedFacets.map(({ facetValueCode, facetValueName, removeQuery: { location } }) => (
            <li key={facetValueCode} className={appliedFacetsStyles['bubbles__item']}>
              <div className={appliedFacetsStyles.bubble}>
                <span className={appliedFacetsStyles['bubble__text']}>{facetValueName.toLowerCase()}</span>
                <button
                  type="button"
                  disabled={isDisabled}
                  onClick={(): void => (appliedFacets.length === 1 ? clearHandler() : removeHandler(location))}
                  className={appliedFacetsStyles['bubble__cta']}
                >
                  <RemoveIcon className={appliedFacetsStyles['bubble__cta-icon']} />
                </button>
              </div>
            </li>
          ))}
        </ul>
      </div>
    </animated.div>
  );
}

export default AppliedFacets;
